module.exports = __webpack_public_path__ + "static/media/customAi.b2129ec1.svg";